var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateDocumentPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 267,
    height: 64,
    viewBox: "0 0 267 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 64,
    rx: 6,
    fill: "#EFF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.875 27.313H28.25C26.9902 27.313 25.782 27.8464 24.8912 28.7957C24.0004 29.7451 23.5 31.0328 23.5 32.3755V72.8752C23.5 74.2178 24.0004 75.5055 24.8912 76.4549C25.782 77.4043 26.9902 77.9376 28.25 77.9376H56.75C58.0098 77.9376 59.218 77.4043 60.1088 76.4549C60.9996 75.5055 61.5 74.2178 61.5 72.8752V45.0316L44.875 27.313Z",
    stroke: "#D3DCE6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.875 27.313V45.0316H61.5",
    stroke: "#D3DCE6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4159 21.8265L41.4159 26.3226M28.7422 26.3226L28.7422 21.8265C28.7422 20.6323 29.1873 19.4871 29.9796 18.6427C30.7718 17.7984 31.8464 17.324 32.9668 17.324C34.0872 17.324 35.1617 17.7984 35.954 18.6427C36.7463 19.4871 37.1913 20.6323 37.1913 21.8265L37.1839 36.4555C37.1839 37.0526 36.9613 37.6252 36.5652 38.0474C36.1691 38.4696 35.6318 38.7067 35.0716 38.7067C34.5114 38.7067 33.9741 38.4696 33.578 38.0474C33.1819 37.6252 32.9593 37.0526 32.9593 36.4555L32.9668 22.9561",
    stroke: "#D3DCE6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 64,
    rx: 6,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.1798,
    height: 26.1798,
    fill: "white",
    transform: "matrix(0.684243 -0.729254 0.684243 0.729254 17.1658 30.0918)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateDocumentPlaceholder);
export default __webpack_public_path__ + "static/media/template_document_placeholder.dd942b7acf17017cb3145221f6c3e303.svg";
export { ForwardRef as ReactComponent };